import React, { useState } from 'react';
import { HashRouter, Routes, Route, Navigate } from 'react-router-dom';
import Layout from './components/layout/Layout';
import Dashboard from './pages/Dashboard';
import CalendarView from './pages/CalendarView';
import TasksView from './pages/TasksView';
import Settings from './pages/Settings';
import DemoView from './pages/DemoView';
import QuickAddModal from './components/modals/QuickAddModal';

export default function App() {
  const [isQuickAddOpen, setIsQuickAddOpen] = useState(false);

  return (
    <HashRouter>
      <Layout onQuickAdd={() => setIsQuickAddOpen(true)}>
        <Routes>
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/calendar" element={<CalendarView />} />
          <Route path="/tasks" element={<TasksView />} />
          <Route path="/demo" element={<DemoView />} />
          <Route path="/settings" element={<Settings />} />
        </Routes>
      </Layout>
      <QuickAddModal 
        isOpen={isQuickAddOpen} 
        onClose={() => setIsQuickAddOpen(false)} 
      />
    </HashRouter>
  );
}